import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';
import { TradesResponse } from '../components/trades/trades.model';

@Injectable({
  providedIn: 'root',
})
export class TradesService extends Query<TradesResponse> {
  document = gql`
    query TradeListQuery($market: Market) {
      trades(market_type: $market) {
        _id
        market_type
        createdAt
        commodity
        grade
        volume_value
        price {
          ... on CashPrice {
            amount
          }
          ... on BasisPrice {
            month
            year
            product_code
            basisPoints
          }
        }
        lot_type
        ship_begin
        ship_end
        destination
        delivery_type
        origin
        product_type
        units
        price_units
        currency
      }
    }
  `;
}
